import styled from "styled-components";
import Button from "@8x8/oxygen-button";
import { COLORS } from "@/react/theme/constants";

export const FlexButton = styled(Button)`
  display: flex;
  align-items: center;
  margin-left: 16px;
`;

export const TableLoadingSpinnerWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${COLORS.background};
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  z-index: 1022;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  position: relative;
`;

export const TableActionsSection = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  align-items: center;
  div {
  }
`;

export const ColumnSelectorWrapper = styled.div`
  min-width: 200px;
`;

export const TableActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 24px;
`;

export const TableHeadContainer = styled.div`
  background-color: ${COLORS.background};
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const TableRowsContainer = styled.div`
  overflow-x: scroll;
  flex: 1;
`;

export const TableFooterContainer = styled.div`
  padding-bottom: 24px;
  padding-top: 24px;
  border-top: 1px solid ${COLORS.secondary};
  display: flex;
  align-items: center;
  background-color: ${COLORS.background};
  z-index: 3;
`;
export const PaginationContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export const FooterButtonsContainer = styled.div`
  margin-right: 24px;
`;

export const FooterButton = styled(Button)`
  margin-right: 16px;
`;
